// Basic
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";

// Libs & Frameworks
import styled from "styled-components";
import { Container, Col, Row } from "react-bootstrap";

// Files
import tanya from "../images/image-tanya.jpg";
import pattern from "../images/pattern-bg.svg";
import next from "../images/icon-next.svg";
import previous from "../images/icon-prev.svg";
import jonh from "../images/image-john.jpg";
import curve from "../images/pattern-curve.svg";
import qoutes from "../images/pattern-quotes.svg";
import frank from "../images/frank.jpg";

// Style
const Parent = styled.section`
  min-width: 100vw;
  padding: 2rem 0;

  .curve {
    position: fixed;
    bottom: 0;
    left: 0;
  }

  .graphics {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .pattern {
      position: absolute;
      z-index: -1;

      img {
        max-width: 115%;
      }
    }

    .person {
      img {
        width: 530px;
        height: 530px;
        object-fit: cover;
        box-shadow: 25px 45px 75px #1e0e4438;
        border-radius: 10px;
      }
    }

    .arrows {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 100px;
      bottom: -15px;
      background: #fff;
      border-radius: 20px;

      button {
        padding: 1.2rem 1.5rem;
        background: #fff;
        left: 0;
        position: relative;
        border: none;
        aoutline: none;

        img {
          position: absolute;
          z-index: 1;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(0.9);
        }

        &:hover {
          background: #ededed !important;
          cursor: pointer;
        }
      }

      .button {
        background: #ccc !important;

        &:hover {
          cursor: auto;
          background: #ccc !important;
        }
      }

      .next {
        border-radius: 0 20px 20px 0;
        width: 50%;
      }

      .previous {
        border-radius: 20px 0 0 20px;
        width: 50%;
      }
    }
  }

  .text {
    text-align: start;
    position: relative;
    z-index: 1;
    color: #1d1370;

    img {
      position: absolute;
      top: -20%;
      left: 20%;
    }

    p {
      font-size: 2em;
      font-weight: 300;
    }

    .info {
      padding-top: 1rem;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 10px;
      font-size: 1.25em;

      .name {
        font-weight: bold;
      }

      .job {
        color: #d3cccc;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .pattern {
      img {
        max-width: 115%;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .c {
      overflow: "hidden" !important;
    }

    .graphic {
      order: 1;

      .graphics {
        .pattern {
          img {
            max-width: 90%;
          }
        }

        .person {
          img {
            width: 500px;
            height: 500px;
          }
        }

        .arrows {
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .txt {
      order: 2;
      padding-top: 5rem;

      .text {
        font-size: 0.8em;
        text-align: center;

        img {
          left: 50%;
          top: -11%;
          transform: translateX(-50%) scale(0.75);
        }

        .info {
          flex-direction: column;
          gap: 5px;
        }
      }
    }
  }

  @media screen and (max-width: 576px) {
    .person {
      img {
        width: 350px !important;
        height: 350px !important;
      }
    }

    .pattern {
      width: 106%;
      overflow: hidden;
      img {
        max-width: 120% !important;
      }
    }

    .text {
      font-size: 0.7em !important;
    }
  }

  @media screen and (max-width: 375px) {
    .pattern {
      width: 107%;
    }

    .person {
      img {
        width: 320px !important;
        height: 320px !important;
      }
    }
  }

  @media screen and (max-width: 320px) {
    .pattern {
      width: 108%;
    }

    .person {
      img {
        width: 300px !important;
        height: 300px !important;
      }
    }
  }
`;

// JSX
function Website() {
  const nextBtn = useRef(null);
  const previousBtn = useRef(null);
  const [person, setPerson] = useState(1);

  // Text Content
  const arr = [
    {
      name: "Frank Manson",
      job: "Junior Back-end Developer",
      para: `“ For example, from my lack of 
      exposure to the front-end field, except that it was a very 
      interesting course and I would recommend it to anyone who is a beginner. ”`,
      image: frank,
    },
    {
      name: "Tanya Sinclair",
      job: "UX Engineer",
      para: `“ I’ve been interested in coding for a while but never taken the jump, until now. 
      I couldn’t recommend this course enough. I’m now in the job of my dreams and so 
      excited about the future. ”`,
      image: tanya,
    },
    {
      name: "John Tarkpor",
      job: "Junior Front-end Developer",
      para: `“ If you want to lay the best foundation possible I’d recommend taking this course. 
      The depth the instructors go into is incredible. I now feel so confident about 
      starting up as a professional developer. ”`,
      image: jonh,
    },
  ];

  // Disabled Btn Conditions
  useEffect(() => {
    if (person == arr.length - 1) {
      nextBtn.current.classList.add("button");
    } else {
      nextBtn.current.style.background = "#fff";
    }

    if (person === 0) {
      previousBtn.current.classList.add("button");
    } else {
      previousBtn.current.style.background = "#fff";
    }
  });

  // Btns Events Handler
  const nextBtnHandler = (e) => {
    previousBtn.current.classList.remove("button");

    if (0 <= person && person < arr.length - 1) {
      setPerson(person + 1);
    }
  };

  const previousBtnHandler = (e) => {
    nextBtn.current.classList.remove("button");

    if (0 < person && person <= arr.length - 1) {
      setPerson(person - 1);
    }
  };

  return (
    <Parent>
      <img src={curve} alt="SVG Curve" className="curve" />
      <Container style={{ width: "100%" }} className="c">
        <Row className="align-items-center justify-content-between">
          <Col sm={12} lg={6} className="txt">
            <div className="text">
              <img src={qoutes} alt="Qoutes Icon" />
              <p>{arr[person].para}</p>
              <div className="info">
                <span className="name">{arr[person].name}</span>
                <span className="job">{arr[person].job}</span>
              </div>
            </div>
          </Col>

          <Col sm={12} lg={6} className="graphic">
            <div className="graphics">
              <div className="pattern">
                <img src={pattern} alt="SVG Bakground" />
              </div>
              <div className="person">
                <img src={arr[person].image} alt="Man or Woman" />
              </div>
              <div className="arrows">
                <button
                  className="previous"
                  onClick={previousBtnHandler}
                  ref={previousBtn}
                >
                  <img src={previous} alt="Previous Arrow" />
                </button>
                <button className="next" onClick={nextBtnHandler} ref={nextBtn}>
                  <img src={next} alt="Nect Arrow" />
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Parent>
  );
}

export default Website;
